// Construção de DOM sem innerHTML com dados: textContent evita XSS por padrão.
export function h(tag, attrs = {}, ...kids) {
  const el = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs || {})) {
    if (v === false || v === null || v === undefined) continue;
    if (k.startsWith('on')) el.addEventListener(k.slice(2).toLowerCase(), v);
    else if (k === 'class') el.className = v;
    else if (k === 'value') el.value = v;
    else el.setAttribute(k, v === true ? '' : v);
  }
  for (const c of kids.flat()) if (c !== null && c !== undefined && c !== false) el.append(c.nodeType ? c : document.createTextNode(String(c)));
  return el;
}
const ICONS = {
  user: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
  cloud: 'M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z',
  off: 'M2 2l20 20M16.7 16.7A8 8 0 0 1 9 20h9M5.8 5.8A8 8 0 0 0 9 20',
  x: 'M18 6 6 18M6 6l12 12',
};
export function icon(name, size = 16) {
  const s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  s.setAttribute('viewBox', '0 0 24 24'); s.setAttribute('width', size); s.setAttribute('height', size);
  s.setAttribute('fill', 'none'); s.setAttribute('stroke', 'currentColor'); s.setAttribute('stroke-width', '2'); s.setAttribute('stroke-linecap', 'round'); s.setAttribute('stroke-linejoin', 'round');
  s.setAttribute('aria-hidden', 'true');
  const p = document.createElementNS('http://www.w3.org/2000/svg', 'path'); p.setAttribute('d', ICONS[name]); s.append(p);
  return s;
}
export function field(label, input) { return h('label', { class: 'pc-field' }, h('span', {}, label), input); }

export function screen(title, subtitle, ...content) {
  document.getElementById('pcScreen')?.remove();
  const el = h('div', { class: 'pc-screen', id: 'pcScreen', role: 'main' },
    h('div', { class: 'pc-card' },
      h('div', { class: 'pc-brand' }, 'Dream Studio 3D'),
      h('h1', {}, title), subtitle ? h('p', { class: 'pc-sub' }, subtitle) : null, ...content));
  document.body.append(el);
  return el;
}
export const closeScreen = () => document.getElementById('pcScreen')?.remove();

export function dialog(title, ...content) {
  const close = () => { el.remove(); document.removeEventListener('keydown', onKey); };
  const onKey = e => { if (e.key === 'Escape') close(); };
  const el = h('div', { class: 'pc-overlay', onclick: e => { if (e.target === el) close(); } },
    h('section', { class: 'pc-dialog', role: 'dialog', 'aria-modal': 'true', 'aria-label': title },
      h('header', {}, h('h2', {}, title), h('button', { class: 'pc-icon-btn', 'aria-label': 'Fechar', onclick: close }, icon('x'))),
      h('div', { class: 'pc-body' }, ...content)));
  document.addEventListener('keydown', onKey);
  document.body.append(el);
  return { el, close };
}
export function errorText(e) {
  const m = e?.message || String(e);
  if (/Invalid login/i.test(m)) return 'E-mail ou senha incorretos.';
  if (/Email not confirmed/i.test(m)) return 'Confirme seu e-mail antes de entrar.';
  if (/Failed to fetch|NetworkError/i.test(m)) return 'Sem conexão com o servidor. Verifique sua internet.';
  if (/rate limit/i.test(m)) return 'Muitas tentativas. Aguarde alguns minutos.';
  return m;
}
